import React from 'react';
import HeroSection from '../components/sections/HeroSection';
import AboutSection from '../components/sections/AboutSection';
import ServicesSection from '../components/sections/ServicesSection';
import WhyChooseSection from '../components/sections/WhyChooseSection';
import DentifiqueSection from '../components/sections/DentifiqueSection';
import TSRSection from '../components/sections/TSRSection';
import ClientsSection from '../components/sections/ClientsSection';
import VendorSection from '../components/sections/VendorSection';
import ShopSection from '../components/sections/ShopSection';
import ContactSection from '../components/sections/ContactSection';
import SupportSection from '../components/sections/SupportSection';

const Home = () => {
  return (
    <>
      <HeroSection />
      <AboutSection />
      <ServicesSection />
      <WhyChooseSection />
      <DentifiqueSection />
      <TSRSection />
      <ClientsSection />
      <VendorSection />
      <ShopSection />
      <ContactSection />
      <SupportSection />
    </>
  );
};

export default Home;